<template>
    <b-card no-body>
        <b-card-header>
            <i class="icon-note"></i>
            <strong>{{ $t('nBox.newNBox') }}</strong>
        </b-card-header>
        <b-card-body>
            <c-form @cancel="goBack" @submit="onSubmit"></c-form>
        </b-card-body>
    </b-card>
</template>

<script>
import CForm from '../components/form'
import i18n from '@/i18n'
import { createNBox } from './api'
import { mapperFormToApi } from '../mappers'
import notification, { success, danger } from '@/lib/notification'

notification.init()

export default {
    name: 'New',
    components: {
        CForm,
    },
    methods: {
        goBack() {
            this.$router.back()
        },
        onSubmit(form, setLoader) {
            setLoader(true)
            createNBox(mapperFormToApi(form))
                .then(() => {
                    this.notificationNBoxCreatedSuccessfully()
                    this.goBack()
                })
                .catch(this.notificationError)
                .finally(() => setLoader(false))
        },
        notificationNBoxCreatedSuccessfully() {
            success(
                i18n.t('notification.createdSuccessfully', {
                    item: 'N-Box',
                })
            )
        },
        notificationError() {
            danger()
        },
    },
}
</script>
